module.exports = __webpack_public_path__ + "static/media/stofferingen-53.6fe70fb4.jpg";